import Vue from 'vue';
export default Vue.component('ed-simple-chip', { 
  name: 'ed-simple-chip',
  props: ['title']
});